import React from 'react';

import { LinkComponent } from './LinkComponent';

interface Props {
	textColor: string;
	fontFamily: string;
	linkColor: string;
}

export const WidgetTerms = (props: Props): React.ReactElement => {
	const { textColor, linkColor, fontFamily } = props;
	return (
		<div className="ui-widget-terms">
			<span style={{ color: `${textColor}`, fontFamily: `${fontFamily}` }}>
				Governed by Flex{' '}
			</span>
			<LinkComponent
				text="Terms and Conditions"
				linkColor={linkColor}
				fontFamily={fontFamily}
				additionalClass="ui-widget-link"
			/>
			<span style={{ color: `${textColor}`, fontFamily: `${fontFamily}` }}>
				and{' '}
			</span>
			<LinkComponent
				text="Privacy Notice"
				linkColor={linkColor}
				fontFamily={fontFamily}
				additionalClass="ui-widget-link"
			/>.
		</div>
	);
};
